import React from "react";
import Button from "../Button";
import { FullRow } from "./FullRow";
import Quotable from "./Quotable";
import { fetchJson, post } from "../../lib/Fetching";
import { deleteQuoteItems } from "../../lib/QuoteActions";
import { confirmDialog } from "../../lib/Dialog";
import TurnaroundPremiums from "./TurnaroundPremiums";

class RootQuoteGroup extends React.Component {
  state = {
    quotable: null,
    loading: true,
    selectedQuotablesGroupId: null,
    selectedForDeletion: false,
    priceHasChanged: false
  };

  componentDidMount() {
    this.fetchData();
  }

  savePrices = () => {
    if (!this.havePricesChanged()) return;
    const { attempt_id } = this.props;
    const prices = this.quotableRef.prices();
    const updatedPrices = prices.filter(price => price.changed);
    if (updatedPrices.length == 0) {
      alert("No prices have been updated.");
      return;
    }
    post("/attempts/update_prices.json", {
      attempt_id,
      prices: updatedPrices
    })
      .then(_ => {
        this.setState({ priceHasChanged: false });
        this.fetchData();
      })
      .catch(e => alert("There was a problem updating prices: " + e.message));
  };

  havePricesChanged = () => this.quotableRef.prices().length > 0;

  fetchData = (clear = false) => {
    const { root_quote_group_id, attempt_id } = this.props;
    this.setState({ loading: true });
    fetchJson("/attempts/quotable.json", { id: attempt_id, root_quote_group_id }).then(
      quotable => {
        console.log(quotable);
        this.setState({
          quotable,
          loading: false,
          selectedForDeletion: false
        });
      }
    );
  };

  rootGroupActions = () => {
    return {
      refreshGroupData: this.fetchData,
      // Used by children components to notify this component that a price has changed
      priceHasChanged: () =>
        !this.state.priceHasChanged && this.setState({ priceHasChanged: true })
    };
  };

  toggleSelected = (quotable, selected) => {
    this.setState({ selectedForDeletion: selected });
  };

  deleteGroup = _ => {
    const { attempt_id, onRemoveGroup, root_quote_group_id } = this.props;
    const { quotable } = this.state;
    confirmDialog(
      "Are you sure",
      `You are about to delete a quote group and all its contents.`,
      () =>
        deleteQuoteItems(attempt_id, null, [quotable.quote_item_id])
          .then(() => onRemoveGroup(root_quote_group_id))
          .catch(e => alert("Could not delete quote group: " + e.message))
    );
  };

  renderLoading() {
    return (
      <FullRow>
        <i className="fa fa-spinner fa-spin" />
        &nbsp; Loading data...
      </FullRow>
    );
  }

  render() {
    const { actions, attempt_id, root_quote_group_id } = this.props;
    const { loading, quotable, selectedForDeletion, priceHasChanged } = this.state;
    const groupActions = this.rootGroupActions();
    return (
      <div className="root_group" style={{ opacity: loading ? 0.2 : 2 }}>
        <div style={{ verticalAlign: "middle", paddingTop: 0, paddingBottom: 15 }}>
          <div className="btn-toolbar">
            <div className="btn-group pull-left" style={{ fontSize: 16, fontWeight: "bold" }}>
              MATRIX: {quotable && quotable.matrix_name}
            </div>
            <div className="btn-group pull-right">
              <Button
                onClick={() => actions.setRootQuoteGroups([quotable.quote_group_id])}
                tiny
                icon={"fa-eye"}
              />
            </div>
            <div className="btn-group pull-right">
              <Button onClick={this.fetchData} tiny icon={"fa-refresh"} />
            </div>
            {priceHasChanged && (
              <div className="btn-group pull-right">
                <Button
                  title="Save Prices"
                  onClick={this.savePrices}
                  primary
                  tiny
                  icon={"fa-save"}
                />
              </div>
            )}
            {selectedForDeletion && (
              <div className="btn-group pull-right">
                <Button
                  onClick={this.deleteGroup}
                  deleting
                  title="Delete Group"
                  tiny
                  icon={"fa-trash"}
                />
              </div>
            )}
          </div>
        </div>
        <TurnaroundPremiums attempt_id={attempt_id} quote_group_id={root_quote_group_id} />
        <table
          className={"table table-condensed table-bordered table-hover"}
          style={{ tableLayout: "fixed" }}
        >
          <thead>
            <tr>
              <th style={{ width: "50px" }}>No.</th>
              <th style={{ width: "40%" }}>Analysis</th>
              <th style={{ width: "150px" }}>LOD</th>
              <th style={{ width: "30%" }}>Technique</th>
              <th style={{ width: "130px" }}>Accreditation</th>
              <th style={{ width: "30px" }}>
                <i className="fa fa-trash" />
              </th>
              <th style={{ width: "100px" }}>Price</th>
            </tr>
          </thead>
          <tbody>
            {quotable ? (
              <Quotable
                ref={ref => (this.quotableRef = ref)}
                selectedForDeletion={selectedForDeletion}
                toggleDeleteSelect={this.toggleSelected}
                allowSelect={true}
                attempt_id={attempt_id}
                quotable={quotable}
                actions={actions}
                rootGroupActions={groupActions}
                initialCollapse={true}
              />
            ) : (
              this.renderLoading()
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default RootQuoteGroup;
